import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

interface PartnerFormNavigationProps {
	onBack: () => void;
	onNext: () => void;
	isLoading?: boolean;
	disabled?: boolean;
}

const PartnerFormNavigation: React.FC<PartnerFormNavigationProps> = ({
	onBack,
	onNext,
	isLoading = false,
	disabled = false,
}) => {
	return (
		<div className='flex justify-between items-center mt-8'>
			<button
				type='button'
				onClick={onBack}
				disabled={disabled}
				className='flex items-center gap-2 text-primary hover:text-primary/80 font-medium disabled:opacity-50 disabled:cursor-not-allowed'
			>
				<ArrowBackIcon fontSize='small' />
				<span>Back</span>
			</button>

			<button
				type='button'
				onClick={onNext}
				disabled={disabled}
				className={`px-8 py-3 text-white rounded-lg transition-colors font-medium ${
					disabled
						? "bg-gray-400 cursor-not-allowed"
						: "bg-primary hover:bg-primary/80"
				}`}
			>
				{isLoading ? "Saving..." : "Save"}
			</button>
		</div>
	);
};

export default PartnerFormNavigation;
